import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function taskReducer(state = initialState.taskTypes, action) {
    switch (action.type) {
        case types.GET_ALL_TASK_TYPES_SUCCESS:
            return action.taskTypes;

        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/taskTypesReducer.js
 **/